import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';

document.querySelectorAll( '[data-industry-carousel]' ).forEach( ( element ) => {
	const slider = element.querySelector( '.swiper' );

	if ( ! slider ) {
		return;
	}

	new Swiper( slider, {
		modules: [ Navigation ],
		slidesPerView: 'auto',
		slidesPerGroup: 1,
		slidesPerGroupAuto: true,
		spaceBetween: 16,
		speed: 500,
		navigation: {
			prevEl: element.querySelector( '[data-slider-prev]' ),
			nextEl: element.querySelector( '[data-slider-next]' ),
		},
		breakpoints: {
			768: {
				spaceBetween: 8
			},
		}
	} );
} );
